import { render, staticRenderFns } from "./QuestionItem.vue?vue&type=template&id=ef4e4738&scoped=true&lang=pug"
import script from "./QuestionItem.vue?vue&type=script&lang=js"
export * from "./QuestionItem.vue?vue&type=script&lang=js"
import style0 from "./QuestionItem.vue?vue&type=style&index=0&id=ef4e4738&prod&lang=scss"
import style1 from "summernote/dist/summernote.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./QuestionItem.vue?vue&type=style&index=2&id=ef4e4738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4e4738",
  null
  
)

export default component.exports